module.exports = __webpack_public_path__ + "static/media/Fletchinder_gaussian2.21bb0a50.png";